module.exports = __webpack_public_path__ + "img/9788992512244.0cb7eb9e.jpg";